import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, EMPTY, Observable, retry, throwError, timer } from 'rxjs';
import { ToastService } from '@shared/services/toastService/toast-service';
import { inject } from '@angular/core';

const RETRY_MAX_COUNT = 3;
const RETRY_BASE_DELAY = 100;

export function catchInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const toastService = inject(ToastService)
  return next(req).pipe(
    retry({
      count: RETRY_MAX_COUNT,
      delay: (error, retryCount) => {
        const delay = Math.pow(2, retryCount) * RETRY_BASE_DELAY;
        return timer(delay);
      }
    }),
    catchError(err => {
      console.error(' > Http call failed after 3 retry attempts! Url: ', req.url)
      toastService.showError(`Error ${err?.error?.statusCode}: ${err?.error?.message}`)
      throw err;
      // console.error(' > Error: ', err);
      // return EMPTY;
    })
  );
}
